<template>
    <div class="modal hide fade in" id="modalAnexos" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edición de Anexos / Observaciones</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                     <div class="row">
                         <div class="form-group col-12">
                            <label>Anexos para {{inventarioDocumento.TipoDocumento.Nombre}} {{inventarioDocumento.Consecutivo}}/{{inventarioDocumento.Anio}}:</label>
                            <textarea type="text" id="anexos_div" class="form-control" v-model="Anexos" />
                        </div>
                     </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" id="botonCancelar" >&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; Cancelar &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;</button>
                    <button type="button" class="btn btn-success" id="botonAceptar" >&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; Guardar &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'

export default {
    props: {
        inventarioDocumento: Object
    },
    data(){
        return{
            Anexos: '',
            editado : false,
            documentoId: 0
        }
    },
    methods:{
        Mostrar: function () {
            $('#modalAnexos').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            $('#botonAceptar').unbind('click').click(this.EditarAnexos);
            },
        ModalClose: function(){
            $('#modalAnexos').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Estatus': false, 'editado': this.editado, 'Anexos': this.Anexos, 'id': this.inventarioDocumento.InventarioDocumentoId});//, "DocumentoId": this.documentoId});
        },
        EditarAnexos :function(){
            if(this.Anexos=='')
            {
                this.Anexos =null;
            }
                comun.SeEstaCargandoInformacion(true);
                var peticion = {'InventarioDocumentoId':this.inventarioDocumento.InventarioDocumentoId, 'Anexos': this.Anexos}
                axios.post(api.conexion + api.ArchivoJudicial.UpdateAnexos, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        this.editado =false;
                        this.ModalClose();
                        comun.SeEstaCargandoInformacion(false);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                        {   
                            //comun.mensajeDeAlerta(respuesta.data.Satisfactorio);
                            this.editado =true;
                            this.ModalClose();
                        }
                    comun.SeEstaCargandoInformacion(false);
                })
                .catch(excepcion => {
                        console.log(excepcion);
                        console.log("fallo por parametros");
                        comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                        comun.SeEstaCargandoInformacion(false);
                });
            
        }
    },
    mounted(){
        this.Anexos = this.inventarioDocumento.Anexos;
        this.Mostrar()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/editAnexos.vue